import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux';

import thunk from 'redux-thunk';

import { rootReducer } from '@app/store/MainPage/Reducers';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/* @ts-ignore */
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(thunk)),
);
